<template>
  <div class="resources-page">
    <div class="uk-section">
      <div class="uk-container uk-container-large">
        <h2 class="resources-title">{{ $t("message.Resources") }}</h2>
        <!-- <p class="home-text-blurb">{{blurb}}</p> -->
        <div class="resources-page__card-container">
          <a class="resources-page__card" v-for="card in cards" :key="card.title" :href="card.url">
            <div>
              <img class="resource-page__card-image" :src="card.image" />
              <div class="resources-page__card-bottom">
                <div class="resources-page-card-inner">
                  <p>{{ $t(`message['${card.title}']`) }}</p>
                </div>
              </div>
            </div>
          </a>
          <div class="resources-page__card resources-page__card-buffer" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
const CARDS = [
  {
    image: require("@/assets/images/anti_racism_campaign_CCNCSJ.jpeg"),
    title: "Anti-Racism Campaign",
    url: "https://ccncsj.ca/"
  },
  {
    image: require("@/assets/images/health_resources_mask.jpeg"),
    title: "Health and Mental Health Resources",
    url: "https://projectprotech.ca/staying-healthy/"
  },
  {
    image: require("@/assets/images/income.jpeg"),
    title: "Income Support Resources",
    url:
      "https://projectprotech.ca/获得服务和支持/收入支持/你需要知道什么/?lang=zh-hans"
  },
  {
    image: require("@/assets/images/legal_support.jpeg"),
    title: "Legal Support",
    url: "https://csalc.ca/"
  },
  {
    image: require("@/assets/images/sex_worker.jpeg"),
    title: "Petition: Sex Workers Income Support",
    url:
      "https://docs.google.com/forms/d/e/1FAIpQLSeC2EeaR4ugeL-F1XBI9L3BNgaQFU8GAwMOFy8NHsRNpyST-A/viewform"
  },
  {
    image: require("@/assets/images/police_resource.jpeg"),
    title: "Police Alternatives",
    url: "http://bit.ly/asians-dont-call-cops"
  },
  {
    image: require("@/assets/images/support_migrant_rights.jpeg"),
    title: "Support Migrant Rights",
    url: "https://migrantrights.ca/covid19/"
  },
  {
    image: require("@/assets/images/support_paid_sick_days_chalk.jpeg"),
    title: "Support Paid Sick Days for Workers",
    url: "https://www.15andfairness.org/covid19_help_now"
  }
];

const BLURB = {
  en: "COVID-19 Anti-Asian Racism Incident Reporting Form",
  fr: "COVID-19 Anti-Asian Racism Incident Reporting Form",
  zhcn: "新冠肺炎反亚裔种族主义事件报告表",
  zhtw: "新冠肺炎反亞裔種族主義事件報告表"
};

export default {
  name: "ResourcesPage",
  computed: {
    blurb() {
      return BLURB[this.$i18n.locale];
    }
  },
  data() {
    return {
      cards: CARDS
    };
  }
};
</script>
<style lang="css">
:root {
  --resource-card-base: 200px;
}
.resources-page {
  height: 100%;
}

.resources-title {
  text-transform: uppercase;
  font-weight: bold;
  font-size: 50px;
}

.resources-page__card-container {
  display: flex;
  justify-content: space-around;
  flex-wrap: wrap;
  padding-top: 50px;
}

.resources-page__card {
  margin-left: 100px;
  margin-right: 100px;
}

.resource-page__card-image {
  height: var(--resource-card-base) !important;
  width: var(--resource-card-base) !important;
}

.resources-page__card-bottom {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 70px;
  width: 100%;

  background: #ffffff;
}

.resources-page-card-inner {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 40px;
  width: var(--resource-card-base);
  background: #ec1d23;
  border-radius: 10px;
  border: none;
  text-align: center;
}

.resources-page-card-inner p {
  font-size: 14px;
  font-weight: 700;
  color: #ffffff;
  margin: 0;
}

.resources-page__card-buffer {
  width: 200px;
}

/* @media only screen and (max-width: 1280px) {
  .resources-page__card {
    margin-left: 45px;
    margin-right: 50px;
  }
} */
@media only screen and (max-width: 1430px) {
  .resources-page__card {
    margin-left: 70px;
    margin-right: 70px;
  }
}
@media only screen and (max-width: 1145px) {
  .resources-page__card {
    margin-left: 40px;
    margin-right: 40px;
  }
}

@media only screen and (max-width: 700px) {
  .resources-title {
    font-size: 30px;
  }
}
</style>
